/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { NO_CATEGORIES_ENABLED_FOR_SALESMODE } from "@constants";
import { Dispatch } from "redux";
import { snapshot } from "valtio";

import { setIsTechProblemModalOpened } from "@store";

import { setCarte } from "@components/OrderTaking/Store/feature";

import { kioskStore, setNavigationIndex } from "@pages/Kiosk/store";

// eslint-disable-next-line
export async function fetcher(url: string): Promise<any> {
    try {
        const response = await fetch(url);

        const text = await response.text();

        const data = text ? JSON.parse(text) : null;

        if (response.ok) {
            return data;
        } else {
            throw new Error("Error while fetching data");
        }
    } catch (error) {
        if ((error as ObjectType).data !== undefined) {
            (error as ObjectType).data = {
                message: (error as ObjectType).message,
            };
        }
        throw error;
    }
}

export function saveMiddlewareIpAddress(middlewareIpAddress: string): void {
    const abortController = new AbortController();
    const timeoutId = setTimeout(() => abortController.abort(), 30000);
    const signal = abortController.signal;
    console.log("Middleware IP address: ", middlewareIpAddress);
    fetch(`http://localhost:6009/api/v1/kiosk/middleware-ip-address`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ middlewareIpAddress }),
        signal,
    })
        .then((response) => {
            if (response.status === 201) {
                console.log(
                    "Successfully send middleware IP Address to Local agent"
                );
                return;
            } else if (response.status === 301) {
                console.log(
                    "Error on writing file or permission denied to save middleware address on local agent"
                );
            }
        })
        .catch((err) => {
            console.log(
                `Something went wrong on save middleware IP address on agent local: ${err}`
            );
        })
        .finally(() => clearTimeout(timeoutId));
}

export const getCatalogueCarte = async (
    dispatch: Dispatch,
    shopDetail: any,
    middlewareApiUrl: any
) => {
    if (!shopDetail?.schema || !shopDetail?.id) {
        console.log(
            "There's an issue while getting catalog ${shopDetail?.schema} or ${shopDetail?.id}"
        );
        return;
    }

    try {
        console.log("Fetching catalogue carte...");

        const response = await fetch(
            `${middlewareApiUrl}/kiosk/${shopDetail.schema}/${
                shopDetail.id
            }/card?timestamp=${Date.now()}`,
            {
                cache: "no-store",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.error === true) {
            console.log(
                `Error from cloud response while getting catalog, with message : ${JSON.stringify(
                    data
                )}`
            );
            return;
        }

        // Get fresh snapshot for selectedSaleModeOrderTaking
        const { selectedSaleModeOrderTaking } = snapshot(kioskStore);

        // Filter active categories for the selected sales mode
        const salesModeActiveCategory =
            selectedSaleModeOrderTaking && data.globalCategory
                ? data.globalCategory.filter(
                      (cat: CategoryType) =>
                          cat.KioskVisibility?.[selectedSaleModeOrderTaking]
                  )
                : [];

        dispatch(
            setCarte({
                ...data,
                nestedCategories: [data.CategoryActive],
            })
        );

        console.log("New catalogue card set successfully");
        console.log("Catalogue new card:", JSON.stringify(data, null, 2));

        //! Check if there are active categories for the selected sales mode
        if (
            selectedSaleModeOrderTaking &&
            salesModeActiveCategory.length === 0
        ) {
            console.log(
                "probleme technique, aucune categorie active pour le mode de vente",
                selectedSaleModeOrderTaking
            );
            setIsTechProblemModalOpened(
                true,
                NO_CATEGORIES_ENABLED_FOR_SALESMODE
            );
            setNavigationIndex(0);
        }
    } catch (error) {
        console.log(
            `Error while getting updating catalog, with message: ${JSON.stringify(
                error
            )}`
        );
    }
};

export async function saveMachineIpAddress({
    middlewareApiUrl,
    franchiseId,
    shopId,
    appId,
    ip,
}: SaveMachineIpVariables): Promise<SaveMachineIpResponse> {
    try {
        const response = await fetch(
            `${middlewareApiUrl}/modifyIpApplication`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    franchiseId,
                    shopId,
                    appId,
                    ip,
                }),
            }
        );

        if (!response.ok) {
            const errorText = await response.text();
            console.error(`Request failed (${response.status}): ${errorText}`);
            throw new Error(
                `Request failed (${response.status}): ${errorText}`
            );
        }

        const data = await response.json();

        if (data.error) {
            console.error("Server reported error:", data.message || data);
            throw new Error(data.message || "Server reported an error");
        }

        console.log("IP modification successful:", data);
        return data;
    } catch (err) {
        console.error("Error while modifying IP application:", err);
        throw err;
    }
}
